export function normailizeOwnerName(owner, language, isSub = true) {
    var name = "";
    if (isSub) {
        if (!!owner?.registerNo) {
            name = owner?.registerNo +
                " - " +
                owner[
                `text${language == "en" ? "" : "Ar"
                }`
                ]
        } else {
            name = owner[
                `text${language == "en" ? "" : "Ar"
                }`
            ]
        }
        return name;
    } else {
        if (!!owner?.ownerRegisterNo) {
            name = owner?.ownerRegisterNo +
                " - " +
                owner[
                `fullName${language == "en" ? "" : "Ar"
                }`
                ]
        } else {
            name = owner[
                `fullName${language == "en" ? "" : "Ar"
                }`
            ]
        }
        return name;
    }
}